module.exports = {
  ...require("./vehicle-colours"),
  ...require("./vehicle-category"),
  ...require("./vehicle-papers"),
  ...require("./cities-data"),
  ...require("./constants"),
}
